var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0_facebook{fill:#1677F0;}\r\n\t.st1_facebook{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0_facebook",
    d: "M35.78,20.44c0-8.76-7.1-15.87-15.87-15.87S4.05,11.68,4.05,20.44c0,7.92,5.8,14.49,13.39,15.68V25.03h-4.03 v-4.59h4.03v-3.5c0-3.98,2.37-6.17,5.99-6.17c1.74,0,3.55,0.31,3.55,0.31v3.91h-2c-1.97,0-2.59,1.22-2.59,2.48v2.98h4.4l-0.7,4.59 h-3.7v11.09C29.98,34.93,35.78,28.36,35.78,20.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_facebook",
    d: "M26.09,25.03l0.7-4.59h-4.4v-2.98c0-1.25,0.61-2.48,2.59-2.48h2v-3.91c0,0-1.82-0.31-3.55-0.31 c-3.62,0-5.99,2.2-5.99,6.17v3.5h-4.03v4.59h4.03v11.09c0.81,0.13,1.64,0.19,2.48,0.19s1.67-0.07,2.48-0.19V25.03H26.09z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.e7c99a26a39f22cf16258549940687a7.svg";
export { ForwardRef as ReactComponent };